/**
 * 域名管理平台
 * 域名管理页面-获取列表接口
 */
/**
 * 请求参数
 */
export interface IZoneParseListReq {
  /**
   * 主机记录
   */
  rr?: string;
  /**
   * 域名
   */
  zone?: string;
  pageNum: number;
  pageSize: number;
}

// 启用禁用
export enum ZONE_STATUS_ENUM{
  /* 启用 */
  ENABLE = 'ENABLE',
  /* 禁用 */
  DISABLE = 'DISABLE',
}

export const DICTIONARY_STATUS_LIST = [
  {
    label: '启用',
    value: ZONE_STATUS_ENUM.ENABLE,
  },
  {
    label: '禁用',
    value: ZONE_STATUS_ENUM.DISABLE,
  },
];

export interface IZoneParseListResListItem {
  /**
   * 主键id
   */
  parseId: string;
  /**
   * 域id
   */
  zoneId: string;
  /**
   * 域name
   */
  zoneName: string;
  /**
   * 主机记录
   */
  rr: string;
  /**
   * 是否启动{启动：ENABLE  禁用：DISABLE}
   */
  dnsState: string;
  /**
   * 记录值（对应阿里云解析value）
   */
  dnsValue: string;
  /**
   * dns类型（对应阿里云上的type）
   */
  dnsType: string;
  /**
   * 备注
   */
  remark: string;
  /**
   * 创建人名称
   */
  creatorName: string;
  /**
   * 创建人名称
   */
  reviserName: string;
  /**
   * 修改人id
   */
  reviserId: string;
  /**
   * 更新时间
   */
  revisedTime: string;
  /**
   * 是否删除：0否 1 是
   */
  isDeleted: string;
  /**
   * 创建人id
   */
  creatorId: string;
  /**
   * 创建时间
   */
  createdTime: string;
}
/**
 * 响应数据
 */
export interface IZoneParseListRes {
  /**
   * 当前页码, 主要给 web 端做分页校验
   */
  page: string;
  /**
   * 总数据量
   */
  total: string;
  /**
   * 分页数据
   */
  list: IZoneParseListResListItem[];
}
/**
 * 域名管理平台
 * 域名管理页面-【禁用/启用】 或 【删除】 操作
 */
/**
 * 请求参数
 */
// 是否删除
export enum ISDEL_STATUS_ENUM{
  /* 删除 */
  YES = 'YES',
  /* 不删除 */
  NO = 'NO',
}

export const ISDEL_STATUS_LIST = [
  {
    label: '启用',
    value: ZONE_STATUS_ENUM.ENABLE,
  },
  {
    label: '禁用',
    value: ZONE_STATUS_ENUM.DISABLE,
  },
];
export interface IZoneHandlerByActionReq {
  /**
   * 解析ids
   */
  parseIds: string[];
  /**
   * 是否启动停用
   * {@link DomainStatusEnum}
   */
  enableState?: ZONE_STATUS_ENUM;
  /**
   * 是否删除  YES 当传yes的时候真正的删除
   * {@link Bool}
   */
  isDeleted?: ISDEL_STATUS_ENUM;
  /**
   * 备注
   */
  remark?: string;
}
/**
 * 域名管理平台
 * 日志管理页面-获取列表
 */
/**
 *  请求参数
 */
export interface IZoneParseLogListReq {
   /**
   * 创建时间（开始）
   */
  createdTimeStart?: string;
  /**
   * 创建时间（结束）
   */
  createdTimeEnd?: string;
  pageNum: number;
  pageSize: number;
 }

/**
 * 响应数据
 */
/**
 * 日志类型
 */
export const enum ZONE_LOG_TYPE_ENUM {
  DOMAIN_ADD = 'DOMAIN_ADD',
  PARSE_ADD = 'PARSE_ADD',
  PARSE_ENABLE = 'PARSE_ENABLE',
  PARSE_DISABLE = 'PARSE_DISABLE',
  PARSE_CONTENT_UPDATE = 'PARSE_CONTENT_UPDATE',
  PARSE_DELETE = 'PARSE_DELETE',
  DOMAIN_ALARM = 'DOMAIN_ALARM',
  DNS_ALARM = 'DNS_ALARM',
}
export const ZONE_LOG_TYPE_LIST = [
  {
    label: '域名添加',
    value: ZONE_LOG_TYPE_ENUM.DOMAIN_ADD,
  },
  {
    label: '解析添加',
    value: ZONE_LOG_TYPE_ENUM.PARSE_ADD,
  },
  {
    label: '解析启用',
    value: ZONE_LOG_TYPE_ENUM.PARSE_ENABLE,
  },
  {
    label: '解析禁用',
    value: ZONE_LOG_TYPE_ENUM.PARSE_DISABLE,
  },
  {
    label: '解析内容发生改更，重新同步dns的值 ',
    value: ZONE_LOG_TYPE_ENUM.PARSE_CONTENT_UPDATE,
  },
  {
    label: '删除解析',
    value: ZONE_LOG_TYPE_ENUM.PARSE_DELETE,
  },
  {
    label: '域名告警消息',
    value: ZONE_LOG_TYPE_ENUM.DOMAIN_ALARM,
  },
  {
    label: '解析告警消息',
    value: ZONE_LOG_TYPE_ENUM.DNS_ALARM,
  },
];
export interface IZoneParseLogListResListItem {
  /**
   * logId
   */
  logId: string;
  /**
   * 域名id
   */
  zoneId: string;
  /**
   * 顶级域名name
   */
  zoneName: string;
  /**
   * 对应云解析主机id
   */
  parseId: string;
  /**
   * 主机记录
   */
  rr: string;
  /**
   * 日志类型
   */
  type: ZONE_LOG_TYPE_ENUM;
  /**
   * 内容
   */
  content: string;
  /**
   * 备注
   */
  remark: string;
  /**
   * 操作人name
   */
  creatorName: string;
  /**
   * 操作人id
   */
  creatorId: string;
  /**
   * 操作时间
   */
  createdTime: string;
}
export interface IZoneParseLogListRes {
  /**
   * 当前页码, 主要给 web 端做分页校验
   */
  page: string;
  /**
   * 总数据量
   */
  total: string;
  /**
   * 分页数据
   */
  list: IZoneParseLogListResListItem[];
}
